export default "__VITE_ASSET__de80f973__"